import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductStorageCapacityService } from '../../../services/product-storage-capacity.service';

@Component({
  selector: 'app-view-product-storage-capacities',
  templateUrl: './view-product-storage-capacities.component.html',
  styleUrls: ['./view-product-storage-capacities.component.css'],
  providers:[ProductStorageCapacityService]
})
export class ViewProductStorageCapacitiesComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productStorageCapacity: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productStorageCapacityService:ProductStorageCapacityService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductStorageCapacity();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductStorageCapacity(){
    this.productStorageCapacityService.get(this.id).subscribe((productStorageCapacity) => {
      this.productStorageCapacity = productStorageCapacity;
    });
  }
  

  saveProductStorageCapacity(){
    this.parseProductsType();
    if (this.productStorageCapacity.id == undefined){
      this.productStorageCapacityService.create(this.returnProductStorageCapacityProperties(this.productStorageCapacity))
      .subscribe((productStorageCapacity) => {
        this.productStorageCapacityService.get(productStorageCapacity.id).subscribe((productStorageCapacity) => {
          this.productStorageCapacity = productStorageCapacity;
          this.router.navigate(['/configuration/productstoragecapacities']);
        });
      });
    }else{
      this.productStorageCapacityService.update(this.returnProductStorageCapacityProperties(this.productStorageCapacity))
      .subscribe((productStorageCapacity) => {
        this.productStorageCapacity = productStorageCapacity;
      });
    }
  }

  returnProductStorageCapacityProperties(productStorageCapacity){
    var properties = {
      name: productStorageCapacity.name,
      product_types: productStorageCapacity.product_types
    }
    if (productStorageCapacity.id){
      properties['id'] = productStorageCapacity.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productStorageCapacity.product_types = "";
    if(this.productStorageCapacity.mobiles === true){
      this.productStorageCapacity.product_types += "1,";
    }
    if(this.productStorageCapacity.consoles === true){
      this.productStorageCapacity.product_types += "2,";
    }
    if(this.productStorageCapacity.products === true){
      this.productStorageCapacity.product_types += "3,";
    }
    if(this.productStorageCapacity.laptops === true){
      this.productStorageCapacity.product_types += "4,";
    }
    this.productStorageCapacity.product_types = this.productStorageCapacity.product_types.substring(0,this.productStorageCapacity.product_types.length - 1);
  }

}




// WEBPACK FOOTER //
// ./src/app/configuration/components/product-storage-capacities/view-product-storage-capacities/view-product-storage-capacities.component.ts